<template>
  <CreateUpdateTemplate
    :routePreventDialog="routePreventDialog"
    :hasChanges="hasChanges"
    :customClass="'create-enquiry create-form'"
    v-if="
      getPermission('adjustment:create') || getPermission('adjustment:update')
    "
  >
    <template v-slot:header-title>
      <div class="form-action d-flex align-center justify-space-between">
        <div
          class="form-title d-flex"
          style="
            font-size: 24px;
            font-weight: 700;
            color: #24326d;
            letter-spacing: 1.5px;
            line-height: 1.11em;
          "
        >
          Adjustment for
          <div
            v-if="reSupplierId"
            class="ml-3 form-title-link cursor-pointer text-h5"
            v-on:click="openDialog('supplier')"
          >
            {{ reSupplier.company_name }}
          </div>
          <template v-else>
            <div
              class="ml-3 form-title-link cursor-pointer text-h5"
              v-on:click="openDialog('supplier')"
            >
              Select a Supplier
              <v-icon large color="cyan">mdi-account-check-outline</v-icon>
            </div>
          </template>
        </div>
        <div>
          <v-chip
            v-if="barcode"
            label
            color="chip-custom-blue"
            outlined
            class="text-white p-3 mr-4"
            style="font-size: 21px !important; font-weight: 700"
          >
            <template>
              {{barcode }}
            </template>
          </v-chip>
        </div>
      </div>
    </template>
    <template v-slot:header-action>
      <div>
        <v-btn
          :disabled="formLoading"
          v-on:click="goBack()"
          class="custom-bold-button custom-grey-border"
          depressed
          >Cancel</v-btn
        >
        <v-btn
          class="custom-bold-button ml-4"
          depressed
          :disabled="!formValid || formLoading"
          :loading="formLoading"
          v-on:click="validateAdjustment()"
          color="cyan white--text"
        >
          Save
        </v-btn>
      </div>
    </template>
    <template v-slot:body>
      <div class="bg-white px-2">
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll"
          style="max-height: calc(100vh - 150px); position: relative"
        >
          <v-form
            ref="createAdjustmentForm"
            v-model.trim="formValid"
            lazy-validation
            v-on:submit.stop.prevent="validateAdjustment()"
          >
            <v-row>
              <v-col md="7">
                <label for="adjustment-Description">Description</label>
                <TextAreaField
                  auto-grow
                  dense
                  filled
                  color="cyan"
                  v-model="adjustment.description"
                  placeholder="Description"
                  solo
                  flat
                  row-height="25"
                  counter="250"
                />
                <v-row>
                  <v-col md="6">
                    <v-layout class="align-center">
                      <v-flex md4
                        ><label class="my-0"
                          ><b>Billing Location</b></label
                        ></v-flex
                      >
                      <v-flex md8 class="position-relative">
                        <!-- <v-icon
                          v-on:click="openDialog('billing')"
                          small
                          class="py-0 my-0"
                          color="cyan"
                          style="position: absolute; top: -8px"
                          >mdi-pencil</v-icon
                        > -->
                      </v-flex>
                    </v-layout>
                    <template v-if="reSupplierBilling?.id">
                      <span
                        v-if="
                          reSupplierBilling &&
                          reSupplierBilling.property_address
                        "
                      >
                        <!--  <v-icon small>mdi-map-marker</v-icon> --></span
                      >
                      <p
                        v-if="
                          reSupplierBilling &&
                          reSupplierBilling.property_address
                        "
                      >
                        <span v-if="reSupplierBilling.property_name"
                          >{{ reSupplierBilling.property_name }}<br
                        /></span>
                        {{ reSupplierBilling.street_1 }},
                        <br
                          v-if="
                            reSupplierBilling.street_2 ||
                            reSupplierBilling.unit_no
                          "
                        />
                        <template v-if="reSupplierBilling.street_2">
                          {{ reSupplierBilling.street_2 }},
                        </template>
                        <template v-if="reSupplierBilling.unit_no">
                          {{ reSupplierBilling.unit_no }},
                        </template>
                        <br />
                        {{ reSupplierBilling.country }}
                        <template
                          v-if="
                            reSupplierBilling &&
                            reSupplierBilling.zip_code != '000000'
                          "
                        >
                          , {{ reSupplierBilling.zip_code }}
                        </template>
                      </p>
                    </template>
                    <template v-else-if="reSupplier?.id">
                      <p class="mb-0 red--text">
                        Please select billing location
                      </p>
                    </template>
                    <template v-else>
                      <p class="mb-0 red--text">Please select supplier</p>
                    </template>
                  </v-col>
                  <v-col md="6">
                    <v-layout class="mt-3 align-center">
                      <v-flex md4
                        ><label class="my-0"
                          ><b>Contact Details</b></label
                        ></v-flex
                      >
                      <v-flex md8 class="position-relative"> </v-flex>
                    </v-layout>
                    <template v-if="reSupplierBillingContact?.id">
                      <p class="mb-0">
                        <show-value
                          :object="reSupplierBillingContact"
                          object-key="display_name"
                          label="Name"
                        />
                      </p>
                      <p class="mb-0">
                        <show-value
                          :object="reSupplierBillingContact"
                          object-key="primary_phone"
                          label="Contact No."
                        />
                      </p>
                      <p class="mb-0">
                        <show-value
                          :object="reSupplierBillingContact"
                          object-key="primary_email"
                          label="Email"
                        />
                      </p>
                    </template>
                    <template v-else-if="reSupplier?.id">
                      <p class="mb-0 red--text">Please select contact person</p>
                    </template>
                    <template v-else>
                      <p class="mb-0 red--text">Please select supplier</p>
                    </template>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="5">
                <table width="100%" style="table-layout: fixed">
                  <!-- <tr>
                    <td width="25%">
                      <label class="font-weight-600 font-size-18 required"
                        >Type</label
                      >
                    </td>
                    <td>
                      <v-autocomplete
                        class="mt-2"
                        dense
                        filled
                        color="cyan"
                        item-color="cyan"
                        :items="Typeadjustment"
                        placeholder="Type"
                        solo
                        flat
                        item-text="name"
                        item-value="name"
                        v-model="adjustment.type"
                        :rules="[
                          validateRules.required(adjustment.type, 'Type'),
                        ]"
                      >
                      </v-autocomplete>
                    </td>
                  </tr> -->
                  <tr>
                    <td width="25%">
                      <label class="font-weight-600 font-size-18"
                        >Reference #</label
                      >
                    </td>
                    <td>
                      <div class="d-flex">
                        <TextField
                          id="adjust-reference"
                          dense
                          filled
                          placeholder="Reference #"
                          solo
                          flat
                          counter="50"
                          v-model.trim="adjustment.reference"
                          color="cyan"
                          :maxlength="100"
                          :rules="[
                            validateRules.minLength(
                              adjustment.reference,
                              'Reference #',
                              2
                            ),
                            validateRules.maxLength(
                              adjustment.reference,
                              'Reference #',
                              100
                            ),
                          ]"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label for="adjust-Date">Date</label>
                    </td>
                    <td>
                      <DatePicker
                        solo
                        mandatory
                        v-on:update:date-picker="updateDate"
                        :pageLoading="pageLoading"
                      ></DatePicker>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <label class="font-weight-600 font-size-18 ml-1 mt-2"
                        >Reason</label
                      >
                    </td>
                    <td>
                      <TextAreaField
                        auto-grow
                        dense
                        filled
                        color="cyan"
                        v-model="adjustment.reason"
                        placeholder="Description"
                        solo
                        flat
                        row-height="25"
                        counter="100"
                      />
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card flat class="custom-grey-border remove-border-radius">
                  <v-card-title class="headline grey lighten-4">
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                    >
                      Choose Product
                    </h3>
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <line-item
                      :key="`adjustment-line-item-${item_key}`"
                      :related-type="6"
                      :related-detail="{}"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" ref="qtNote">
                <v-card flat class="remove-border-radius">
                  <v-expand-transition>
                    <v-layout class="mt-3">
                      <v-flex md12>
                        <DocumnetList v-model="adjustment.attachments">
                        </DocumnetList>
                      </v-flex>
                    </v-layout>
                  </v-expand-transition>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </perfect-scrollbar>
        <supplier-select
          :dialog="reSupplierDialog"
          @close="closeSupplierDialog"
        />
      </div>
    </template>
  </CreateUpdateTemplate>
</template>

<style scoped>
.door-type-action {
  height: 20px;
  margin-left: 10px;
  background-color: #002557 !important;
  border-color: #002557 !important;
}
</style>
<script>
import AdjustmentLineItem from "@/view/pages/product/adjustment/Adjustment-Line-Item.vue";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { mapGetters } from "vuex";
import SupplierSelect from "@/view/pages/product/adjustment/SupplierSelect";
import {
  SET_SUPPLIER_DIALOG_STATUS,
  CLEAR_SUPPLIER,
} from "@/core/services/store/customer.module";
import { CLEAR_LINE_ITEM } from "@/core/services/store/line.item.module";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import CommonMixin from "@/core/plugins/common-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { POST,QUERY } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import DatePicker from "@/view/pages/partials/Datepicker";
import ValidationMixin from "@/core/plugins/validation-mixin";
import ShowValue from "@/view/components/ShowValue.vue";

import DocumnetList from "@/view/pages/DocumnetList";

export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "product-adjustment-create",
  data() {
    return {
      barcode : null,
      show_line_items: false,
      show_notes_attachment: false,
      serial_number_dialog: false,
      dialog_key: Number(new Date()),
      item_key: Number(new Date()),
      adjustmentCreated: false,
      confirm_loading: false,
      adjustment: {
        reference: null,
        type: null,
        date: null,
        reason: null,
        description: null,
      },
      pageLoading: false,
      calculation_type: [
        {
          id: 1,
          text: "Subtraction",
        },
        {
          id: 2,
          text: "Addition",
        },
      ],
      Typeadjustment: [
        {
          id: 0,
          name: "Purchase Order",
        },
        {
          id: 1,
          name: "Delivery Order",
        },
        {
          id: 2,
          name: "Quotation",
        },
      ]
    };
  },
  components: {
    DatePicker,
    DocumnetList,
    CreateUpdateTemplate,
    "supplier-select": SupplierSelect,
    TextAreaField,
    "show-value": ShowValue,
    "line-item": AdjustmentLineItem,
  },
  watch: {
    reSupplierId: {
      deep: true,
      immediate: true,
      handler() {
        (this.item_key = Number(new Date())),
          this.$store.dispatch(CLEAR_LINE_ITEM);
      },
    },
  },
  methods: {
    openDialog(type) {
      this.dialog_key = Number(new Date());
      this.$store.commit(SET_SUPPLIER_DIALOG_STATUS, false);
      this.propertyType = null;
      this.propertyLabel = null;
      this.propertyDialog = false;
      this.contactType = null;
      this.contactDialog = false;

      if (type == "supplier") {
        this.$store.commit(SET_SUPPLIER_DIALOG_STATUS, true);
      } else {
        if (!this.reSupplierId) {
          ErrorEventBus.$emit("update:error", "Please Select Supplier.");
          return false;
        }
        if (type == "billing") {
          this.propertyType = "billing";
          this.propertyLabel = "Billing Location";
          this.propertyDialog = true;
        }
        if (type == "billing-contact") {
          this.contactType = "billing";
          this.contactDialog = true;
        }
        if (type == "property") {
          this.propertyType = "property";
          this.propertyLabel = "Site Location";
          this.propertyDialog = true;
        }
        if (type == "property-contact") {
          this.contactType = "property";
          this.contactDialog = true;
        }
      }
      this.$store.dispatch(CLEAR_LINE_ITEM);
    },
    closeSupplierDialog() {
      this.$store.commit(SET_SUPPLIER_DIALOG_STATUS, false);
    },

     validateAdjustment() {
       if (
          !this.lSelectedLineItem ||
          !this.lSelectedLineItem.length
        ) {
          ErrorEventBus.$emit("update:error", "Please Select Product");
          return false;
        }

     let error = true;

      if (this.lSelectedLineItem?.length > 0) {
        this.lSelectedLineItem.forEach((row) => {
            if (!row.calculation_type) {
              ErrorEventBus.$emit(
                "update:error",
                `${row.barcode}, Please Select Type`
              );
              error = false;
              return false;
            }
            if (row?.adjusted_quantity < 1 || !row?.adjusted_quantity) {
              ErrorEventBus.$emit(
                "update:error",
                `${row.barcode}, Please Enter Adjusted Quantity`
              );
              error = false;
              return false;
            }
            if (row?.adjusted_quantity  !=  row?.adjust_serial_array.length && row?.isSerialized > 0) {
              ErrorEventBus.$emit(
                "update:error",
                `${row.barcode}, Ensure that the adjusted quantity entered matches the Serial Number count`
              );
              error = false;
              return false;
            }
          });
      }

      if (!error) {
        return false;
      }

      const validateStatus = this.$refs.createAdjustmentForm.validate();

      const formErrors = this.validateForm(this.$refs.createAdjustmentForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

      if (validateStatus) {
        this.onSubmit();
      }
    },

    async onSubmit() {
    
      const request = {
        ...this.adjustment,
        attachments: this.adjustment.attachments,
        supplier_id: this.reSupplierId,
        property: this.reSupplierPropertyId,
        billing: this.reSupplierBillingId,
        property_contact_person: this.reSupplierPropertyContactId,
        calculation: this.vCalculations,
        billing_contact_person: this.reSupplierBillingContactId,
       "line_items": this.lSelectedLineItem,
      };

      let requestType = POST;
      let requestURL = "adjustment";

      this.formLoading = true;

      this.$store
        .dispatch(requestType, { url: requestURL, data: request })
        .then(() => {
          this.$store.dispatch(CLEAR_SUPPLIER);
          this.$store.dispatch(CLEAR_LINE_ITEM);
          this.adjustmentCreated = true;
          this.$nextTick(() => {
            this.$router.push(this.getDefaultRoute("adjustment"));
          });
        })
        .catch(() => {
          this.formLoading = false;
        });
    },
  
    updateDate(date) {
      this.adjustment.date = date;
    },
     get_attributes() {
      this.pageLoading = true;
      this.$store
        .dispatch(QUERY, {
          url: "adjustment/options",         
        })
        .then((response) => {
          this.barcode = response?.data?.barcode ?? null
          const _this = this;
          _this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Adjustment", route: "adjustment" },
            { title: "Create" },
            { title: this.barcode },
          ]);
        })
        .catch((error) => {
          this.logError(error);
          this.goBack();
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters([
      "reSupplier",
      "reSupplierProperty",
      "reSupplierPropertyContact",
      "reSupplierBilling",
      "reSupplierBillingContact",
      "reSupplierDialog",
      "reSupplierId",
      "lSelectedLineItem"
    ]),
  },

  mounted() {
    this.get_attributes();
  },

  destroyed() {
    this.$store.dispatch(CLEAR_SUPPLIER);
    this.$store.dispatch(CLEAR_LINE_ITEM);
  },
  beforeCreate() {
    this.$store.dispatch(CLEAR_SUPPLIER);
    this.$store.dispatch(CLEAR_LINE_ITEM);
  },
  created() {
    const _this = this;
    _this.productCreateadjustmentId = _this.lodash.toSafeInteger(
      _this.$route.query.generate_adjustment
    );
    _this.product_type = _this.$route.query.product_type;
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.adjustmentCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
};
</script>
